import * as React from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
import { COLOR_SCHEME_LIGHT, COLOR_SCHEME_DARK } from "theme/constants";
import Switch from "components/common/Switch";
import useThemeMode from "theme/hooks/useThemeMode";
const ThemeModeToggleWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;
const ModeIcon = styled(Icon)(
  ({ theme, $currentMode }) => css`
    opacity: ${$currentMode ? "1" : "0.5"};
    color: ${$currentMode ? theme.colors.variant.danger : theme.colors.variant.darkest.default};
  `
);
const ThemeModeToggle = () => {
  const { currentMode, toggleThemeMode, loadingTheme } = useThemeMode();
  const loadingLightMode = currentMode === COLOR_SCHEME_DARK && loadingTheme;
  const loadingDarkMode = currentMode === COLOR_SCHEME_LIGHT && loadingTheme;
  return /* @__PURE__ */ React.createElement(ThemeModeToggleWrap, null, /* @__PURE__ */ React.createElement(
    ModeIcon,
    {
      name: loadingLightMode ? "progress_activity" : "light_mode",
      spin: loadingLightMode,
      $currentMode: currentMode === COLOR_SCHEME_LIGHT
    }
  ), /* @__PURE__ */ React.createElement(
    Switch,
    {
      checked: currentMode === COLOR_SCHEME_DARK,
      disabled: loadingLightMode || loadingDarkMode,
      onChange: toggleThemeMode
    }
  ), /* @__PURE__ */ React.createElement(
    ModeIcon,
    {
      name: loadingDarkMode ? "progress_activity" : "dark_mode",
      spin: loadingDarkMode,
      $currentMode: currentMode === COLOR_SCHEME_DARK
    }
  ));
};
export default ThemeModeToggle;
